import { h, Fragment } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper';
import { useEffect, useMemo, useRef, useState } from 'preact/hooks';
import Media from 'utils/media';
import ProductGalleryModal from './product-gallery-modal';

const ProductGalleryMobile = ({ currentProduct: { media, enableMute } }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(null);
  const slider = useRef(null);
  

  const paginationConfig = useMemo(() => {
    if (document.body.classList.contains('theme-ml')) {
      return {
        type: 'fraction',
        horizontalClass:
          'body-1 right-16 !clear-left !flex items-center pr-16 justify-end',
      };
    }
    return {
      clickable: false,
      horizontalClass: '!flex gap-8 pr-16 !bottom-16 justify-end',
      bulletClass: 'w-8 h-8 pb-6 rounded-full bg-white',
      bulletActiveClass: '!bg-black',
    };
  }, []);

  const handleClick = (index) => {
    setActiveIndex(index);
    const body = document.querySelector('body');
    if (index !== null) {
      body.classList.add('overflow-hidden');
    } else {
      body.classList.remove('overflow-hidden');
    }
  };

  useEffect(() => {
    if (slider.current) {
      if (media.length > 1) {
        slider.current.enable();
      } else {
        slider.current.disable();
      }
    }
  }, [media]);

  return (
    <>
      {activeIndex !== null ? (
        <ProductGalleryModal
          media={media}
          initialIndex={activeIndex}
          onClose={() => handleClick(null)}
          enableMute ={enableMute?.value}
        />
      ) : null}
      <div className="w-full overflow-hidden relative">
        <Swiper
          modules={[Pagination, FreeMode]}
          loop={true}
          freeMode={true}
          pagination={paginationConfig}
          onInit={(swiper) => {
            slider.current = swiper;
          }}
          onSlideChange={(state) => {
            setCurrentSlide(state.activeIndex - 1);
          }}
        >
          {media.map((item, index) => (
            <SwiperSlide key={item.id}>
              <div key={item.previewImage.id} className="relative pb-[136.5%]">
                <Media
                  {...item}
                  onClick={() => handleClick(index)}
                  className="absolute inset-0 object-cover h-full w-full"
                  activeIndex={activeIndex}
                  lazyLoad={index !== 0}
                  slideId={index}
                  currentSlide={currentSlide}
                  srcWidths={{
                    sm: 640,
                    md: 768,
                    lg: 1024,
                    xl: 1280,
                    '2xl': 1536,
                  }}
                  enableMute={enableMute?.value}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default ProductGalleryMobile;
